const OrgCategoryType = {
  Province: 5, // Tỉnh
  District: 10, // Huyện
  Manager: 15, // Chủ quản
  School: 20, // Trường
  Department: 25, // Phòng ban
  Commune: 30, // Xã
};

export default OrgCategoryType;
